export enum EResponsavelTaxasCartao {
    Comprador = 1,
    Vendedor = 2,
}
